import { render, staticRenderFns } from "./horizontalSide.vue?vue&type=template&id=1f162bd8&scoped=true"
import script from "./horizontalSide.vue?vue&type=script&lang=js"
export * from "./horizontalSide.vue?vue&type=script&lang=js"
import style0 from "./horizontalSide.vue?vue&type=style&index=0&id=1f162bd8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@7.0.0-bridge.0_@babel+core@7.29.7__cac_q4nveoxp7n4czahn54be2wnk2a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f162bd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\new-site\\wetech-website-admin\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f162bd8')) {
      api.createRecord('1f162bd8', component.options)
    } else {
      api.reload('1f162bd8', component.options)
    }
    module.hot.accept("./horizontalSide.vue?vue&type=template&id=1f162bd8&scoped=true", function () {
      api.rerender('1f162bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/sideBar/horizontalSide.vue"
export default component.exports